
<template>
  <div>
    <CCard>
      <CCardBody>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <CForm @submit.stop.prevent="handleSubmit(submit)">
            <CRow>
              <CCol md="6">
                <validation-provider rules="required" v-slot="{ errors }" name="Instansi">
                  <div role="group" class="form-group">
                    <label class>Instansi</label>
                    <v-select
                      v-model="form.id_instansi"
                      :options="optionsInstansi"
                      label="nama_instansi"
                      :reduce="instansi => instansi.id_instansi"
                      :filterable="false"
                      @search="onSearch"
                      :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                    ></v-select>
                    <div class="invalid-feedback" v-if="errors[0]">{{errors[0]}}</div>
                  </div>
                </validation-provider>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <validation-provider rules="required" v-slot="{ errors }" name="Unit Kerja Induk">
                  <div role="group" class="form-group">
                    <label class>Unit Kerja Induk</label>
                    <v-select
                      v-model="form.id_unit_kerja"
                      :options="optionsUnitKerja"
                      label="nama_unit_kerja"
                      :reduce="unit_kerja => unit_kerja.id_unit_kerja"
                      :filterable="false"
                      @search="onSearchUnitKerja"
                      :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                    ></v-select>
                    <div class="invalid-feedback" v-if="errors[0]">{{errors[0]}}</div>
                  </div>
                </validation-provider>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <validation-provider rules="required" v-slot="{ errors }" name="Unit Kerja">
                  <div role="group" class="form-group">
                    <label class>Unit Kerja</label>
                    <v-select
                      v-model="form.unk"
                      :options="optionsUnitKerjaInduk"
                      label="nama_unit_kerja"
                      :reduce="unit_kerja => unit_kerja.tunit"
                      :filterable="true"
                      :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                    ></v-select>
                    <div class="invalid-feedback" v-if="errors[0]">{{errors[0]}}</div>
                  </div>
                </validation-provider>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6">
                <validation-provider rules="required" v-slot="{ errors }" name="Jabatan Umum">
                  <div role="group" class="form-group">
                    <label class>Jabatan Umum</label>
                    <v-select
                      v-model="form.id_jabatan_umum"
                      :options="optionsJabatanUmum"
                      label="nama_jabatan"
                      :reduce="jabatan_umum => jabatan_umum.id"
                      :filterable="false"
                      @search="onSearchJabatan"
                      :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                    ></v-select>
                    <div class="invalid-feedback" v-if="errors[0]">{{errors[0]}}</div>
                  </div>
                </validation-provider>
              </CCol>
              <CCol md="3">
                <validation-provider
                  rules="required|numeric"
                  v-slot="{ errors }"
                  name="Kelas Jabatan"
                >
                  <CInput
                    label="Kelas Jabatan"
                    placeholder="Kelas Jabatan"
                    v-model="form.kelas_jabatan"
                    :invalid-feedback="errors[0]"
                    :isValid="!errors[0]"
                  ></CInput>
                </validation-provider>
              </CCol>
              <CCol md="3">
                <validation-provider rules="required|numeric" v-slot="{ errors }" name="ABK">
                  <CInput
                    label="ABK"
                    placeholder="ABK"
                    v-model="form.abk"
                    :invalid-feedback="errors[0]"
                    :isValid="!errors[0]"
                  ></CInput>
                </validation-provider>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6" class="text-left">
                <CSpinner color="success" size="sm" v-if="loading" />
                <CButton color="primary" class="px-4" type="submit" v-else>Simpan</CButton>
              </CCol>
              <CCol col="6" class="text-right">
                <!-- <CButton color="link" class="px-0">Forgot password?</CButton>
                <CButton color="link" class="d-lg-none">Register now!</CButton>-->
              </CCol>
            </CRow>
          </CForm>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VSelect from "vue-select";
import _ from "lodash";
import Swal from "sweetalert2";
export default {
  name: "FormAbkUmum",
  props: ["item"],
  components: {
    ValidationProvider,
    ValidationObserver,
    VSelect,
  },
  data() {
    return {
      errorMessage: null,
      form: {
        id_instansi: null,
        unk: null,
        id_unit_kerja: null,
        id_jabatan_umum: null,
        kelas_jabatan: null,
        abk: null,
      },
      loading: false,
      optionsInstansi: [],
      optionsUnitKerja: [],
      optionsJabatanUmum: [],
      optionsUnitKerjaInduk: [],
    };
  },
  watch: {
    "form.id_instansi": function () {
      this.searchUnitKerja("", this);
    },
    "form.id_unit_kerja": function () {
      this.onSearchUnitKerjaInduk("");
    },
    item: function (item) {
      if (item) {
        const array = [];
        array.push(item.mst_instansi);
        this.optionsInstansi = array;
        const array2 = [];
        array2.push(item.mst_unit_kerja);
        this.optionsUnitKerja = array2;
        const array3 = [];
        array3.push(item.mst_jabatan_umum);
        this.optionsJabatanUmum = array3;
        

        this.form.id_instansi = item.id_instansi.toString();
        this.form.id_unit_kerja = item.id_unit_kerja;
        this.form.unk = item.unk.toString().trim();
        this.form.id_jabatan_umum = parseInt(item.id_jabatan_umum);
        this.form.kelas_jabatan = item.kelas_jabatan;
        this.form.abk = item.abk;
      }
    },
  },
  methods: {
    loadSelect() {
      this.search("", this);
      this.searchJabatanUmum("", this);
    },
    async submit() {
      const vm = this;
      try {
        this.loading = true;
        let { status } = this.item
          ? await this.$store.dispatch("jabatan_umum_abk/update", {
              data: this.form,
              id: vm.item.id,
            })
          : await this.$store.dispatch("jabatan_umum_abk/store", this.form);
        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "Sukses",
            text: "Data berhasil tersimpan!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            if (!vm.item) {
              vm.form.id_instansi = null;
              vm.form.id_unit_kerja = null;
              vm.form.id_jabatan_umum = null;
              vm.form.kelas_jabatan = null;
              vm.form.abk = null;
              requestAnimationFrame(() => {
                this.$refs.observer.reset();
              });
            }
            vm.$emit("done");
          });
        }
      } catch (x) {
        console.log(x);
      } finally {
        this.loading = false;
      }
    },
    async onSearch(search, loading) {
      loading(true);
      await this.search(search, this);
      loading(false);
    },
    search: _.debounce(async (search, vm) => {
      let options = await vm.$store.dispatch(
        "master_instansi/autocomplete",
        search
      );
      if (search) vm.optionsInstansi = options;
    }, 300),
    async onSearchUnitKerja(search, loading) {
      loading(true);
      await this.searchUnitKerja(search, this);
      loading(false);
    },
    searchUnitKerja: _.debounce(async (search, vm) => {
      let options = await vm.$store.dispatch("master_unit_kerja/autocomplete", {
        search: search,
        id_instansi: vm.form.id_instansi,
        parent: "",
      });
      if (search) vm.optionsUnitKerja = options;
    }, 300),
    async onSearchUnitKerjaInduk() {
      let options = await this.$store.dispatch(
        "master_unit_kerja/autocomplete",
        {
          search: "",
          id_instansi: this.form.id_instansi,
          parent: this.form.id_unit_kerja,
        }
      );
      this.optionsUnitKerjaInduk = options;
    },
    async onSearchJabatan(search, loading) {
      loading(true);
      await this.searchJabatanUmum(search, this);
      loading(false);
    },
    searchJabatanUmum: _.debounce(async (search, vm) => {
      let options = await vm.$store.dispatch(
        "master_jabatan_umum/autocomplete",
        search
      );
      if (search) vm.optionsJabatanUmum = options;
    }, 500),
  },
};
</script>
